<!-- @format -->

<ng-container *transloco="let t">
  <fudis-dl [columns]="{ sm: 1, md: 2 }" [rowGap]="'xl'">
    @if (courseUnitRealisation.teachingLanguageUrn | codeLocalizedName | async; as teachingLanguage) {
      <fudis-dl-item>
        <fudis-dt [contentText]="t('FIELD_NAMES.teachingLanguageUrn')" />
        <fudis-dd [contentText]="teachingLanguage" />
      </fudis-dl-item>
    }
    @if (courseUnitRealisation.studyFormat; as studyFormat) {
      <fudis-dl-item>
        <fudis-dt [contentText]="t('COURSE_UNIT_REALISATION_INFO.STUDY_FORMAT')" />
        <fudis-dd>
          <sis-localized-markup-string-view [content]="studyFormat" />
        </fudis-dd>
      </fudis-dl-item>
    }
    @if (courseUnitRealisation.learningEnvironments?.length > 0) {
      <fudis-dl-item>
        <fudis-dt [contentText]="t('FIELD_NAMES.learningEnvironments')" />
        <fudis-dd>
          @if (courseUnitRealisation.learningEnvironmentDescription) {
            <p>{{ courseUnitRealisation.learningEnvironmentDescription | localizedString }}</p>
          }
          @for (learningEnvironment of courseUnitRealisation.learningEnvironments; track $index) {
            <a fudisLink [title]="learningEnvironment.name" [external]="true" [href]="learningEnvironment.url"></a>
          }
        </fudis-dd>
      </fudis-dl-item>
    }
    @if (courseUnitRealisation.learningMaterial; as learningMaterial) {
      <fudis-dl-item>
        <fudis-dt [contentText]="t('FIELD_NAMES.learningMaterial')" />
        <fudis-dd><sis-localized-markup-string-view [content]="learningMaterial" /></fudis-dd>
      </fudis-dl-item>
    }
    @if (courseUnitRealisation.customCodeUrns; as customCodeUrns) {
      <fudis-dl-item>
        <fudis-dt [contentText]="t('CUSTOM_CODE_VALUES.TITLE')" />
        <fudis-dd>
          <sis-custom-code-urns [codeUrnsMap]="customCodeUrns" [classificationScope]="'course-unit-realisation'" />
        </fudis-dd>
      </fudis-dl-item>
    }
    @if (courseUnitRealisation.literature?.length > 0) {
      <fudis-dl-item>
        <fudis-dt [contentText]="t('FIELD_NAMES.literature')" />
        <fudis-dd>
          @for (literature of courseUnitRealisation.literature; track literature) {
            <sis-literature [literature]="literature" />
          }
        </fudis-dd>
      </fudis-dl-item>
    }
    @if (courseUnitRealisation.additionalInfo; as additionalInfo) {
      <fudis-dl-item>
        <fudis-dt [contentText]="t('FIELD_NAMES.additionalInfo')" />
        <fudis-dd><sis-localized-markup-string-view [content]="additionalInfo" /></fudis-dd>
      </fudis-dl-item>
    }
    @if (alternativeCourseUnits$ | async; as alternativeCourseUnits) {
      @if (alternativeCourseUnits?.length > 0) {
        <fudis-dl-item>
          <fudis-dt [contentText]="t('COURSE_UNIT_REALISATION_INFO.ALTERNATIVE_COURSE_UNITS')" />
          <fudis-dd>
            <p class="sis-guidance">{{ t("COURSE_UNIT_REALISATION_INFO.ALTERNATIVE_CU_HELP") }}</p>
            @for (courseUnit of alternativeCourseUnits; track courseUnit.id) {
              <span
                >{{ courseUnit.code }} {{ courseUnit.name | localizedString }} /
                @if (assessmentItemsByCourseUnitId$ | async; as assessmentItemsByCourseUnitId) {
                  @for (assessmentItem of assessmentItemsByCourseUnitId.get(courseUnit.id); track assessmentItem.id) {
                    <span>{{ assessmentItem.name | localizedString }}</span
                    ><span> ({{ assessmentItem.credits | creditRange }}</span
                    >){{ $last ? "" : ", " }}
                  }
                }
              </span>
            }
          </fudis-dd>
        </fudis-dl-item>
      }
    }
    @if (courseUnitRealisation.responsibilityInfos?.length > 0) {
      <fudis-dl-item>
        <fudis-dt [contentText]="t('FIELD_NAMES.responsibilityInfos')" />
        <fudis-dd>
          <sis-responsibility-infos
            [responsibilityInfos]="courseUnitRealisation.responsibilityInfos"
            [roleVisibilityAndOrder]="[
              'urn:code:course-unit-realisation-responsibility-info-type:contact-info',
              'urn:code:course-unit-realisation-responsibility-info-type:responsible-teacher',
              'urn:code:course-unit-realisation-responsibility-info-type:teacher',
            ]">
          </sis-responsibility-infos>
        </fudis-dd>
      </fudis-dl-item>
    }
  </fudis-dl>
  @if (courseUnitRealisation.organisations?.length > 0) {
    <div class="form-group-mimic mt-5">
      <sis-organisation-role-share
        [organisations]="courseUnitRealisation.organisations"
        [organisationRoleUrn]="'urn:code:organisation-role:responsible-organisation'"></sis-organisation-role-share>
      @if (hasCoordinatingOrganisations()) {
        <sis-organisation-role-share
          [organisations]="courseUnitRealisation.organisations"
          [organisationRoleUrn]="'urn:code:organisation-role:coordinating-organisation'"></sis-organisation-role-share>
      }
    </div>
  }
</ng-container>
